import { Loading } from "@ligo/layout-design-core";
import NotFound from "components/notFound";
import Layout from "layout";
import { useProfile } from "providers";
import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import RequireAuth from "./requireAuth";
import RequirePermission from "./requirePermission";

const AdministrativePage = lazy(() => import("pages/administrative"));
const AttendancePage = lazy(() => import("pages/attendance"));
const AuditPage = lazy(() => import("pages/audit"));
const AuthPage = lazy(() => import("pages/auth"));
const DashboardPage = lazy(() => import("pages/dashboard"));
const NotepadPage = lazy(() => import("pages/notepad"));
const RegistrationPage = lazy(() => import("pages/registration"));
const ReportPage = lazy(() => import("pages/report"));
const TelemetryPage = lazy(() => import("pages/telemetry"));
const VideoCallPage = lazy(() => import("pages/videoCall"));
const WelcomePage = lazy(() => import("pages/welcome"));

// const TextEditor = lazy(() => import("components/textEditor")); // ToDo: Remover após estar pronto

const RoutesMap = () => {
  const { user } = useProfile();

  return (
    <Suspense fallback={<Loading $centered />}>
      <Routes>
        <Route path="authentication/*" element={<AuthPage />} />

        <Route path="external/videoCall/*" element={<VideoCallPage />} />
        <Route path="external/report/*" element={<ReportPage />} />
        <Route path="external/dashboard/*" element={<DashboardPage />} />
        <Route path="external/notepad/*" element={<NotepadPage />} />
        <Route path="external/telemetry/*" element={<TelemetryPage />} />

        {/* <Route
          path="external/textEditor/*"
          element={
            <PageContainer>
              <TextEditor
                onChange={(value: string) => console.log("onChange", value)}
                onUpload={(files: Array<File>) =>
                  console.log("onUpload", files)
                }
              />
            </PageContainer>
          }
        /> */}

        <Route path="/" element={<RequireAuth children={<Layout />} />}>
          <Route index element={<WelcomePage />} />
          <Route
            path="attendance/*"
            element={
              <RequirePermission
                children={<AttendancePage />}
                permission={user?.hasAccessAttend}
              />
            }
          />
          <Route
            path="dashboard/*"
            element={
              <RequirePermission
                children={<DashboardPage />}
                permission={user?.hasAccessDashboard}
              />
            }
          />
          <Route
            path="audit/*"
            element={
              <RequirePermission
                children={<AuditPage />}
                permission={user?.hasAccessAudit}
              />
            }
          />
          <Route
            path="report/*"
            element={
              <RequirePermission
                children={<ReportPage />}
                permission={user?.hasAccessReport}
              />
            }
          />
          <Route
            path="registration/*"
            element={
              <RequirePermission
                children={<RegistrationPage />}
                permission={user?.hasAccessRegister}
              />
            }
          />
          <Route
            path="administrative/*"
            element={
              <RequirePermission
                children={<AdministrativePage />}
                permission={user?.hasAccessAdmin}
              />
            }
          />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default RoutesMap;
